// extracted by css-extract-rspack-plugin
export default {"Heading":"YourSponsorships-module__Heading__JIZuR","Text":"YourSponsorships-module__Text__Jx_aG","UnderlineNav":"YourSponsorships-module__UnderlineNav__M7IY6"};